/**
 * useSecurityConfig — fetches public security/captcha config so the
 * Login/Register pages know whether to render Turnstile + which site
 * key to use. Cached for 5 min.
 *
 * Returns `{turnstile: {enabled, site_key}}` (nullable).
 */
import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export function useSecurityConfig() {
  return useQuery({
    queryKey: ["public-security-config"],
    queryFn: async () => (await api.get("/public/security-config")).data,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
